module.exports = __webpack_public_path__ + "static/media/unviewed.32ebdc1d.svg";